import { render, staticRenderFns } from "./worklist.vue?vue&type=template&id=bfbb3228&"
import script from "./worklist.vue?vue&type=script&lang=js&"
export * from "./worklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports